// import React, { useEffect, useState, JSX } from 'react';
// import {
// 	Box,
// 	CardContent,
// 	Typography,
// 	Divider,
// 	Table,
// 	TableHead,
// 	TableBody,
// 	TableRow,
// 	TableCell,
// 	Button,
// 	Dialog,
// 	DialogTitle,
// 	DialogContent,
// 	DialogActions,
// 	Skeleton,
// 	IconButton,
// 	Chip,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import Grid from '@mui/material/Grid2';
// import { Line } from 'react-chartjs-2';
// import {
// 	Chart as ChartJS,
// 	CategoryScale,
// 	LinearScale,
// 	PointElement,
// 	LineElement,
// 	Title,
// 	Tooltip,
// 	Legend,
// } from 'chart.js';
// import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
// import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
// import InventoryIcon from '@mui/icons-material/Inventory';
// import PeopleIcon from '@mui/icons-material/People';
// import { useNavigate } from 'react-router-dom';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import {
// 	ProductCategory,
// 	ProductDetails,
// 	ProductInfo,
// 	ProductStats,
// 	StyledCrossIconButton,
// 	StyledProductArticle,
// 	StyledTableCell,
// 	StyledTableRow,
// } from './../component/ThemeComponent';
// import SalesCard from '../component/StyledComponents/SalesComponent';
// import { Dashboardapi } from '../../services/api/DashboardAPI';

// interface CardData {
// 	id: string;
// 	title: string;
// 	amount: string;
// 	description: string;
// 	icon?: JSX.Element;
// 	cardColor: string;
// 	textColor: string;
// 	url: string;
// }

// interface ChartData {
// 	monthlySales: number;
// 	month: string;
// 	year: number;
// }

// interface Product {
// 	id: number;
// 	name: string;
// 	category: string;
// 	price: number;
// 	sold: number;
// 	stock: number;
// }

// interface Order {
// 	id: number;
// 	orderId: string;
// 	name: string;
// 	email: string;
// 	orderedItems: string;
// 	date: string;
// 	orderStatus: 'New Order' | 'Shipped' | 'Cancelled' | 'Process';
// 	itemQuantity: string;
// 	totalPrice: string;
// 	paymentStatus: 'Paid' | 'Unpaid';
// }

// ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

// const HomePage = () => {
// 	const defaultCardData: CardData[] = [
// 		{
// 			id: '1',
// 			title: 'Total Plans',
// 			amount: '100',
// 			description: 'Counts',
// 			icon: <AttachMoneyIcon style={{ color: '#39318A' }} />,
// 			cardColor: `linear-gradient(90deg,rgba(128, 68, 246, 1) 0%, rgba(122, 147, 252, 1) 35%, rgba(122, 108, 249, 1) 100%)`,
// 			textColor: '#fff',
// 			url: '/',
// 		},
// 		{
// 			id: '2',
// 			title: 'Total Active Plans',
// 			amount: '1000',
// 			description: 'Counts',
// 			icon: <ShoppingCartIcon style={{ color: '#39318A' }} />,
// 			cardColor: `radial-gradient( circle 655px at 42.6% 14.2%,  rgba(39,170,248,1) 0%, rgba(56,56,56,1) 56.9%, rgba(0,0,0,1) 100.2% )`,
// 			textColor: '#fff',
// 			url: '/',
// 		},
// 		{
// 			id: '3',
// 			title: 'Total InActive Plans',
// 			amount: '40000',
// 			description: 'Counts',
// 			icon: <InventoryIcon style={{ color: '#39318A' }} />,
// 			cardColor:
// 				'linear-gradient( 102.2deg,  rgba(251,166,60,1) 1.2%, rgba(213,57,44,1) 107.5% )',
// 			textColor: '#fff',
// 			url: '/',
// 		},
// 		{
// 			id: '4',
// 			title: 'Total OTT Icons',
// 			amount: '250',
// 			description: 'Counts',
// 			icon: <PeopleIcon style={{ color: '#39318A' }} />,
// 			cardColor:
// 				'linear-gradient( 90.2deg,  rgba(61,156,161,1) -2.4%, rgba(122,212,217,1) 52.7%, rgba(61,156,161,1) 100.8% )',
// 			textColor: '#fff',
// 			url: '/',
// 		},
// 	];

// 	// const defaultProducts: Product[] = [
// 	// 	{ id: 1, name: 'Product 1', category: 'Category 1', price: 0, sold: 0, stock: 0 },
// 	// 	{ id: 2, name: 'Product 2', category: 'Category 2', price: 0, sold: 0, stock: 0 },
// 	// ];

// 	const navigate = useNavigate();
// 	const [cardData, setCardData] = useState<CardData[]>(defaultCardData);
// 	const [chartData, setChartData] = useState<ChartData[]>([]);
// 	const [products, setProducts] = useState<Product[]>([]);
// 	const [recentOrder, setRecentOrder] = useState<Order[]>([]);
// 	const [loading, setLoading] = useState(false);
// 	const [selectedOrder, setSelectedOrder] = useState<Order>();
// 	const [open, setOpen] = useState(false);

// 	useEffect(() => {
// 		const fetchData = async () => {
// 			try {
// 				setLoading(true);
// 				const response = await Dashboardapi();

// 				const cardDataWithIcons = [
// 					{
// 						id: '1',
// 						title: 'Total Plans',
// 						amount: response.data.totalSales.toString(),
// 						description: 'Counts',
// 						icon: <AttachMoneyIcon style={{ color: '#39318A' }} />,
// 						cardColor: `linear-gradient(90deg,rgba(128, 68, 246, 1) 0%, rgba(122, 147, 252, 1) 35%, rgba(122, 108, 249, 1) 100%)`,
// 						textColor: '#fff',
// 						url: '/',
// 					},
// 					{
// 						id: '2',
// 						title: 'Total Active Plans',
// 						amount: response.data.totalOrders.toString(),
// 						description: 'Counts',
// 						icon: <ShoppingCartIcon style={{ color: '#39318A' }} />,
// 						cardColor: `radial-gradient( circle 655px at 42.6% 14.2%,  rgba(39,170,248,1) 0%, rgba(56,56,56,1) 56.9%, rgba(0,0,0,1) 100.2% )`,
// 						textColor: '#fff',
// 						url: '/',
// 					},
// 					{
// 						id: '3',
// 						title: 'Total InActive Plans',
// 						amount: response.data.totalProducts.toString(),
// 						description: 'Counts',
// 						icon: <InventoryIcon style={{ color: '#39318A' }} />,
// 						cardColor:
// 							'linear-gradient( 102.2deg,  rgba(251,166,60,1) 1.2%, rgba(213,57,44,1) 107.5% )',
// 						textColor: '#fff',
// 						url: '/',
// 					},
// 					{
// 						id: '4',
// 						title: 'Total OTT Icons',
// 						amount: response.data.totalCustomers.toString(),
// 						description: 'Counts',
// 						icon: <PeopleIcon style={{ color: '#39318A' }} />,
// 						cardColor:
// 							'linear-gradient( 90.2deg,  rgba(61,156,161,1) -2.4%, rgba(122,212,217,1) 52.7%, rgba(61,156,161,1) 100.8% )',
// 						textColor: '#fff',
// 						url: '/',
// 					},
// 				];

// 				setCardData(cardDataWithIcons);

// 				// Prepare sales data for each month
// 				const monthlySales = Array(12).fill(0);
// 				response.data.salesOverview.forEach((item: any) => {
// 					const monthIndex = item._id.month - 1; // Months are 1-indexed in the API response
// 					monthlySales[monthIndex] = item.monthlySales;
// 				});

// 				setChartData(monthlySales);

// 				setProducts(
// 					response.data.bestSellingProducts.map((product: any) => ({
// 						id: product._id,
// 						name: product.name,
// 						category: 'Category', // Assuming category is not provided in the API response
// 						price: product.price,
// 						sold: product.totalSold,
// 						stock: product.inStock,
// 					}))
// 				);
// 				setRecentOrder(
// 					response.data.recentOrders.map((order: any) => ({
// 						id: order._id,
// 						orderId: order.orderId,
// 						name: order.shippingAddress.name,
// 						email: order.shippingAddress.email, // Assuming email is not provided in the API response
// 						orderedItems: order.items.map((item: any) => item.name).join(', '),
// 						date: new Date(order.createdAt).toLocaleString('en-US', {
// 							day: '2-digit',
// 							month: 'short',
// 							year: 'numeric',
// 							hour: '2-digit',
// 							minute: '2-digit',
// 							hour12: true,
// 						}),
// 						orderStatus: order.orderStatus === 'New' ? 'New Order' : order.orderStatus,
// 						itemQuantity: order.items.length.toString(),
// 						totalPrice: `${order.totalAmount.toFixed(2)}`,
// 						paymentStatus: order.paymentStatus === 'Unpaid' ? 'Unpaid' : 'Paid',
// 					}))
// 				);
// 			} catch (error) {
// 				console.error('Error fetching data:', error);
// 			} finally {
// 				setLoading(false);
// 			}
// 		};

// 		fetchData();
// 	}, []);

// 	const labels = [
// 		'Jan',
// 		'Feb',
// 		'Mar',
// 		'Apr',
// 		'May',
// 		'Jun',
// 		'Jul',
// 		'Aug',
// 		'Sep',
// 		'Oct',
// 		'Nov',
// 		'Dec',
// 	];

// 	const handleViewAllClick = () => {
// 		navigate('/order'); // Navigate to the "View All" page
// 	};

// 	const handleClickOpen = (order: Order) => {
// 		setSelectedOrder(order);
// 		setOpen(true);
// 	};

// 	const handleClose = () => {
// 		setOpen(false);
// 	};

// 	const getStatusColor = (status: string) => {
// 		switch (status) {
// 			case 'Paid':
// 				return 'success'; // green
// 			case 'Unpaid':
// 				return 'error'; // red
// 			case 'Pending':
// 				return 'warning'; // orange
// 			case 'Processing':
// 				return 'secondary'; // blue
// 			case 'Shipped':
// 				return 'info'; // indigo
// 			case 'Delivered':
// 				return 'success'; // green
// 			case 'Completed':
// 				return 'success'; // green
// 			case 'Cancelled':
// 				return 'error'; // red
// 			case 'New':
// 				return 'primary'; // blue
// 			default:
// 				return 'default'; // grey
// 		}
// 	};

// 	const data = {
// 		labels: labels,
// 		datasets: [
// 			{
// 				label: 'Sales Overview',
// 				data: chartData,
// 				borderColor: 'rgba(0, 150, 136, 1)',
// 				backgroundColor: 'rgba(0, 150, 136, 0.2)',
// 				tension: 0.4,
// 				pointBackgroundColor: 'rgba(0, 150, 136, 1)',
// 				fill: false,
// 			},
// 		],
// 	};

// 	const config = {
// 		responsive: true,
// 		plugins: {
// 			legend: {
// 				display: false,
// 			},
// 			title: {
// 				display: false,
// 			},
// 		},
// 		scales: {
// 			x: {
// 				grid: {
// 					display: false,
// 				},
// 			},
// 			y: {
// 				grid: {
// 					color: '#e0e0e0',
// 				},
// 				ticks: {
// 					callback: function (value: number | string) {
// 						return `₹${value}`;
// 					},
// 				},
// 			},
// 		},
// 	};

// 	return (
// 		<Box sx={{ p: 2 }}>
// 			<div style={{ marginBottom: '24px' }}>
// 				<Typography
// 					gutterBottom
// 					style={{
// 						fontFamily: 'Poppins',
// 						fontWeight: '700',
// 						fontSize: '24px',
// 						margin: '0px',
// 					}}
// 					color="secondary"
// 				>
// 					Dashboard
// 				</Typography>
// 				<Typography
// 					gutterBottom
// 					style={{
// 						fontFamily: 'Poppins',
// 						fontWeight: '400',
// 						fontSize: '16px',
// 						// color: '#006D48',
// 					}}
// 					color="secondary"
// 				>
// 					Welcome to your yegovah admin dashboard.
// 				</Typography>
// 			</div>
// 			<Grid container spacing={2}>
// 				{cardData.map((card, index) => (
// 					<Grid size={{ xs: 12, sm: 6, md: 3 }} key={index} component="div">
// 						<SalesCard
// 							title={card.title}
// 							amount={card.amount}
// 							description={card.description}
// 							icon={card.icon}
// 							cardColor={card.cardColor}
// 							textColor={card.textColor}
// 							url={card.url}
// 						/>
// 					</Grid>
// 				))}
// 			</Grid>

// 			<Grid container spacing={2} sx={{ mt: 2 }}>
// 				<Grid size={{ xs: 12, sm: 12, md: 8 }} component="div">
// 					<Box
// 						sx={{
// 							backgroundColor: '#fff',
// 							borderRadius: 2,
// 							p: 2,
// 							boxShadow: 1,
// 							border: '1px solid #39318A',
// 						}}
// 					>
// 						<Typography variant="h6" sx={{ mb: 2 }}>
// 							Sales Overview
// 						</Typography>
// 						<Line data={data} options={config} />
// 					</Box>
// 				</Grid>
// 				<Grid size={{ xs: 12, sm: 12, md: 4 }} component="div">
// 					<StyledProductArticle
// 						sx={{
// 							maxHeight: '428px', // Set a maximum height
// 							overflowY: 'auto', // Enable vertical scrolling
// 						}}
// 					>
// 						<Typography variant="h6" fontWeight={700} sx={{ mb: 2 }}>
// 							Best Selling Products
// 						</Typography>
// 						{products.map((product) => (
// 							<React.Fragment key={product.id}>
// 								<CardContent sx={{ padding: '8px' }}>
// 									<Typography
// 										variant="body1"
// 										sx={{ fontWeight: 500, margin: '0px' }}
// 									>
// 										{product.name}
// 									</Typography>
// 									<ProductCategory
// 										variant="body2"
// 										sx={{ paddingLeft: '0px', margin: '0px' }}
// 									>
// 										{product.category}
// 									</ProductCategory>
// 									<ProductDetails sx={{ marginBottom: '0px' }}>
// 										<ProductInfo>
// 											<Typography variant="body1">
// 												₹{product.price ? product.price.toFixed(2) : '0.00'}
// 											</Typography>
// 										</ProductInfo>
// 										<ProductStats>
// 											<Typography variant="body2" color="textSecondary">
// 												{product.sold} sold
// 											</Typography>
// 											<Typography variant="body2" color="textSecondary">
// 												{product.stock} in stock
// 											</Typography>
// 										</ProductStats>
// 									</ProductDetails>
// 								</CardContent>
// 								{product.id < products.length && (
// 									<Divider sx={{ backgroundColor: '#e0e0e0' }} />
// 								)}
// 							</React.Fragment>
// 						))}
// 					</StyledProductArticle>
// 				</Grid>
// 			</Grid>

// 			<Box
// 				sx={{
// 					backgroundColor: '#fff',
// 					borderRadius: 2,
// 					p: 2,
// 					boxShadow: 1,
// 					border: '1px solid #39318A',
// 					mt: 2,
// 					overflowX: 'auto', // Enable horizontal scrolling if needed
// 				}}
// 			>
// 				<Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
// 					<Typography variant="h4">Recent Orders</Typography>
// 					<Button variant="outlined" onClick={handleViewAllClick}>
// 						View All
// 					</Button>
// 				</Box>
// 				<Table
// 					stickyHeader
// 					aria-label="sticky table"
// 					sx={{
// 						// tableLayout: { xs: 'auto', sm: 'auto', md: 'fixed' }, // Ensure the table respects the container width
// 						width: '100%',
// 						overflowX: 'auto',
// 					}}
// 				>
// 					<TableHead>
// 						<TableRow>
// 							<TableCell>Order Id</TableCell>
// 							<TableCell>Email</TableCell>
// 							<TableCell>Ordered Items</TableCell>
// 							<TableCell>Date</TableCell>
// 							<TableCell>Order Status</TableCell>
// 							<TableCell>Item</TableCell>
// 							<TableCell>Total Price</TableCell>
// 							<TableCell>Payment Status</TableCell>
// 							<TableCell>Actions</TableCell>
// 						</TableRow>
// 					</TableHead>
// 					<TableBody>
// 						{loading ? (
// 							// Display skeleton while loading
// 							[...Array(5)].map((_, index) => (
// 								<TableRow key={index}>
// 									{[...Array(9)].map((_, cellIndex) => (
// 										<TableCell key={cellIndex}>
// 											<Skeleton variant="text" />
// 										</TableCell>
// 									))}
// 								</TableRow>
// 							))
// 						) : recentOrder.length > 0 ? (
// 							recentOrder.map((order) => (
// 								<StyledTableRow key={order.id}>
// 									<TableCell>{order.orderId}</TableCell>
// 									<TableCell>{order.email}</TableCell>
// 									<TableCell>{order.orderedItems}</TableCell>
// 									<TableCell>
// 										{new Date(order.date)
// 											.toLocaleString('en-US', {
// 												day: '2-digit',
// 												month: 'short',
// 												year: 'numeric',
// 												hour: '2-digit',
// 												minute: '2-digit',
// 												hour12: true,
// 											})
// 											.replace(',', '')}
// 									</TableCell>
// 									<StyledTableCell status={order.orderStatus}>
// 										{order.orderStatus}
// 									</StyledTableCell>
// 									<TableCell>{order.itemQuantity}</TableCell>
// 									<TableCell>₹{order.totalPrice}</TableCell>
// 									{/* <StyledTableCell status={order.paymentStatus}>
// 										{order.paymentStatus}
// 									</StyledTableCell> */}
// 									<TableCell>
// 										<Chip
// 											label={order.paymentStatus}
// 											color={getStatusColor(order.paymentStatus)}
// 											size="small"
// 											variant="outlined"
// 										/>
// 									</TableCell>
// 									<TableCell>
// 										<IconButton aria-label="delete" size="small">
// 											<VisibilityIcon
// 												// sx={{
// 												// 	cursor: 'pointer',
// 												// 	'&:hover': { color: '#86BCAB' },
// 												// }}
// 												onClick={() => handleClickOpen(order)}
// 											/>
// 										</IconButton>
// 									</TableCell>
// 								</StyledTableRow>
// 							))
// 						) : (
// 							<TableRow>
// 								<TableCell colSpan={9}>No recent orders</TableCell>
// 							</TableRow>
// 						)}
// 					</TableBody>
// 				</Table>

// 				{/* Dialog for Order Details */}
// 				<Dialog open={open} onClose={handleClose}>
// 					{/* <DialogTitle>Order Details</DialogTitle> */}
// 					<DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
// 						<span>Order Details</span>
// 						<StyledCrossIconButton onClick={handleClose}>
// 							<CloseIcon />
// 						</StyledCrossIconButton>
// 					</DialogTitle>
// 					<DialogContent>
// 						{selectedOrder && (
// 							<div>
// 								<p>
// 									<strong>Order ID:</strong> {selectedOrder.orderId}
// 								</p>
// 								<p>
// 									<strong>Email:</strong> {selectedOrder.email}
// 								</p>
// 								<p>
// 									<strong>Ordered Items:</strong> {selectedOrder.orderedItems}
// 								</p>
// 								<p>
// 									<strong>Date:</strong> {selectedOrder.date}
// 								</p>
// 								<p>
// 									<strong>Order Status:</strong> {selectedOrder.orderStatus}
// 								</p>
// 								<p>
// 									<strong>Item:</strong> {selectedOrder.itemQuantity}
// 								</p>
// 								<p>
// 									<strong>Total Price:</strong>₹{selectedOrder.totalPrice}
// 								</p>
// 								<p>
// 									<strong>Payment Status:</strong> {selectedOrder.paymentStatus}
// 								</p>
// 							</div>
// 						)}
// 					</DialogContent>
// 					<DialogActions>
// 						<Button onClick={handleClose}>Close</Button>
// 					</DialogActions>
// 				</Dialog>
// 			</Box>
// 		</Box>
// 	);
// };

// export default HomePage;
// =========================================================================================================================
// =========================================================================================================================
// =========================================================================================================================
// =========================================================================================================================
// =========================================================================================================================
// =========================================================================================================================
// =========================================================================================================================
// =========================================================================================================================
// =========================================================================================================================
// =========================================================================================================================
// =========================================================================================================================
// =========================================================================================================================
import React, { useEffect, useState, JSX } from 'react';
import {
	Box,
	// CardContent,
	Typography,
	// Divider,
	// Table,
	// TableHead,
	// TableBody,
	// TableRow,
	// TableCell,
	// Button,
	// Dialog,
	// DialogTitle,
	// DialogContent,
	// DialogActions,
	// Skeleton,
	// IconButton,
	// Chip,
} from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid2';
// import { Line } from 'react-chartjs-2';
// import {
// 	Chart as ChartJS,
// 	CategoryScale,
// 	LinearScale,
// 	PointElement,
// 	LineElement,
// 	Title,
// 	Tooltip,
// 	Legend,
// } from 'chart.js';
// import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import InventoryIcon from '@mui/icons-material/Inventory';
// import Inventory2Icon from '@mui/icons-material/People';
// import { useNavigate } from 'react-router-dom';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import {
// 	ProductCategory,
// 	ProductDetails,
// 	ProductInfo,
// 	ProductStats,
// 	StyledCrossIconButton,
// 	StyledProductArticle,
// 	StyledTableCell,
// 	StyledTableRow,
// } from './../component/ThemeComponent';
import SalesCard from '../component/StyledComponents/SalesComponent';
import { Dashboardapi } from '../../services/api/DashboardAPI';

interface CardData {
	id: string;
	title: string;
	amount: string;
	description: string;
	icon?: JSX.Element;
	cardColor: string;
	textColor: string;
	url: string;
}

// interface ChartData {
// 	monthlySales: number;
// 	month: string;
// 	year: number;
// }

// interface Product {
// 	id: number;
// 	name: string;
// 	category: string;
// 	price: number;
// 	sold: number;
// 	stock: number;
// }

// interface Order {
// 	id: number;
// 	orderId: string;
// 	name: string;
// 	email: string;
// 	orderedItems: string;
// 	date: string;
// 	orderStatus: 'New Order' | 'Shipped' | 'Cancelled' | 'Process';
// 	itemQuantity: string;
// 	totalPrice: string;
// 	paymentStatus: 'Paid' | 'Unpaid';
// }

// ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const HomePage = () => {
	const defaultCardData: CardData[] = [
		{
			id: '1',
			title: 'Total Plans',
			amount: '100',
			description: 'Counts',
			icon: <Inventory2Icon style={{ color: '#39318A' }} />,
			cardColor: `linear-gradient(90deg,rgba(128, 68, 246, 1) 0%, rgba(122, 147, 252, 1) 35%, rgba(122, 108, 249, 1) 100%)`,
			textColor: '#fff',
			url: '/',
		},
		{
			id: '2',
			title: 'Total Active Plans',
			amount: '1000',
			description: 'Counts',
			icon: <InventoryIcon style={{ color: '#39318A' }} />,
			cardColor: `radial-gradient( circle 655px at 42.6% 14.2%,  rgba(39,170,248,1) 0%, rgba(56,56,56,1) 56.9%, rgba(0,0,0,1) 100.2% )`,
			textColor: '#fff',
			url: '/',
		},
		{
			id: '3',
			title: 'Total InActive Plans',
			amount: '40000',
			description: 'Counts',
			icon: <InventoryIcon style={{ color: '#39318A' }} />,
			cardColor:
				'linear-gradient( 102.2deg,  rgba(251,166,60,1) 1.2%, rgba(213,57,44,1) 107.5% )',
			textColor: '#fff',
			url: '/',
		},
		{
			id: '4',
			title: 'Total OTT Icons',
			amount: '250',
			description: 'Counts',
			icon: <Inventory2Icon style={{ color: '#39318A' }} />,
			cardColor:
				'linear-gradient( 90.2deg,  rgba(61,156,161,1) -2.4%, rgba(122,212,217,1) 52.7%, rgba(61,156,161,1) 100.8% )',
			textColor: '#fff',
			url: '/',
		},
	];

	// const defaultProducts: Product[] = [
	// 	{ id: 1, name: 'Product 1', category: 'Category 1', price: 0, sold: 0, stock: 0 },
	// 	{ id: 2, name: 'Product 2', category: 'Category 2', price: 0, sold: 0, stock: 0 },
	// ];

	// const navigate = useNavigate();
	const [cardData, setCardData] = useState<CardData[]>(defaultCardData);
	// const [chartData, setChartData] = useState<ChartData[]>([]);
	// const [products, setProducts] = useState<Product[]>([]);
	// const [recentOrder, setRecentOrder] = useState<Order[]>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const fetchData = async () => {
			try {
				console.log(loading);
				setLoading(true);
				const response = await Dashboardapi();

				console.log(response.data, 'dashboard api respones==============>');
				const cardDataWithIcons = [
					{
						id: '1',
						title: 'Total Plans',
						amount: response.data.totalPlans.toString(),
						description: 'Counts',
						icon: <Inventory2Icon style={{ color: '#39318A' }} />,
						cardColor: `linear-gradient(90deg,rgba(128, 68, 246, 1) 0%, rgba(122, 147, 252, 1) 35%, rgba(122, 108, 249, 1) 100%)`,
						textColor: '#fff',
						url: '/',
					},
					{
						id: '2',
						title: 'Total Active Plans',
						amount: response.data.activePlans.toString(),
						description: 'Counts',
						icon: <ShoppingCartIcon style={{ color: '#39318A' }} />,
						cardColor: `radial-gradient( circle 655px at 42.6% 14.2%,  rgba(39,170,248,1) 0%, rgba(56,56,56,1) 56.9%, rgba(0,0,0,1) 100.2% )`,
						textColor: '#fff',
						url: '/',
					},
					{
						id: '3',
						title: 'Total InActive Plans',
						amount: response.data.inactivePlans.toString(),
						description: 'Counts',
						icon: <InventoryIcon style={{ color: '#39318A' }} />,
						cardColor:
							'linear-gradient( 102.2deg,  rgba(251,166,60,1) 1.2%, rgba(213,57,44,1) 107.5% )',
						textColor: '#fff',
						url: '/',
					},
					{
						id: '4',
						title: 'Total OTT Icons',
						amount: response.data.totalOttIcons.toString(),
						description: 'Counts',
						icon: <Inventory2Icon style={{ color: '#39318A' }} />,
						cardColor:
							'linear-gradient( 90.2deg,  rgba(61,156,161,1) -2.4%, rgba(122,212,217,1) 52.7%, rgba(61,156,161,1) 100.8% )',
						textColor: '#fff',
						url: '/',
					},
				];

				setCardData(cardDataWithIcons);

				// Prepare sales data for each month
				const monthlySales = Array(12).fill(0);
				response.data.salesOverview.forEach((item: any) => {
					const monthIndex = item._id.month - 1; // Months are 1-indexed in the API response
					monthlySales[monthIndex] = item.monthlySales;
				});
			} catch (error) {
				console.error('Error fetching data:', error);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, []);

	// const labels = [
	// 	'Jan',
	// 	'Feb',
	// 	'Mar',
	// 	'Apr',
	// 	'May',
	// 	'Jun',
	// 	'Jul',
	// 	'Aug',
	// 	'Sep',
	// 	'Oct',
	// 	'Nov',
	// 	'Dec',
	// ];

	return (
		<Box sx={{ p: 2 }}>
			<div style={{ marginBottom: '24px' }}>
				<Typography
					gutterBottom
					style={{
						fontFamily: 'Poppins',
						fontWeight: '700',
						fontSize: '24px',
						margin: '0px',
					}}
					color="secondary"
				>
					Dashboard
				</Typography>
				<Typography
					gutterBottom
					style={{
						fontFamily: 'Poppins',
						fontWeight: '400',
						fontSize: '16px',
						// color: '#006D48',
					}}
					color="secondary"
				>
					Welcome to your yegovah admin dashboard.
				</Typography>
			</div>
			<Grid container spacing={2}>
				{cardData.map((card, index) => (
					<Grid size={{ xs: 12, sm: 6, md: 3 }} key={index} component="div">
						<SalesCard
							title={card.title}
							amount={card.amount}
							description={card.description}
							icon={card.icon}
							cardColor={card.cardColor}
							textColor={card.textColor}
							url={card.url}
						/>
					</Grid>
				))}
			</Grid>
		</Box>
	);
};

export default HomePage;
